import { message } from 'antd'
import lodash from 'lodash'
import type { Reducer, Effect } from 'umi'
import { produce } from 'immer'

export type RobotModelState = {
  goodsKnowledge: any
  robot_shop: any
  qa_list: any
}

export type RobotModelType = {
  namespace: 'robot'
  state: RobotModelState
  effects: {
    BotQandA: Effect
    ProductSearch: Effect
    ProductAttributes: Effect
    ProductComparison: Effect
    CommodityKnowledge: Effect
  }
  reducers: {
    setState: Reducer<RobotModelState>
    resetState: Reducer<RobotModelState>
  }
  subscriptions: any
}

export interface ISearchKnowledge {
  keyword?: string
  limit?: number
  nick?: string
  sort?: string
}

const initialState = {
  goodsKnowledge: {},
  robot_shop: {},
  qa_list: {},
}

const RequestInterface = ({ url, method, cgateToken, data }) => {
  if (method === 'post') {
    return fetch(url, {
      method: 'post',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        Authorization: `Bearer ${cgateToken}`,
        'Content-Type': 'application/json',
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .catch((err) => console.log(err, 'err'))
  } else if (method === 'get') {
    return fetch(url, {
      method: 'get',
      headers: {
        Authorization: `Bearer ${cgateToken}`,
        'Content-Type': 'application/json',
      },
    })
      .then((res) => res.json())
      .catch((err) => console.log(err, 'err'))
  }
}

const getHost = () => {
  const isDev =
    window.location.host?.startsWith('localhost') ||
    window.location.host?.startsWith('training-dev-lane')
  if (isDev) {
    return 'https://cgate-dev-lane.xiaoduoai.com'
  } else {
    return 'https://cgate.xiaoduoai.com'
  }
}
const getSearchStr = (val) => {
  const keys = Object.keys(val)

  const keysList = []
  keys.forEach((key) => {
    keysList.push(`${key}=${val[key]}`)
  })
  return keysList.join('&')
}

const UserModel: RobotModelType = {
  namespace: 'robot',
  state: {
    goodsKnowledge: {},
    robot_shop: {}, // 当前会话的商品信息
    qa_list: {},
  },

  effects: {
    // 测试机器人问答
    *BotQandA({ payload }, { call, select, put }) {
      const cgateToken = yield select((store) => store.user.cgateToken)
      const shop_id = payload?.shop_id

      const cgate_token = cgateToken[shop_id]
      delete payload.shop_id
      const response = yield call(RequestInterface, {
        url: `${getHost()}/openapi/us/admin/robot/reply`,
        method: 'post',
        cgateToken: cgate_token,
        data: payload,
      })
      return response
    },
    // 商品搜索
    *ProductSearch({ payload }, { call, select, put }) {
      const cgateToken = yield select((store) => store.user.cgateToken)
      const shop_id = yield select((store) => store.robot?.robot_shop?.shop_id)
      const cgate_token = cgateToken[shop_id]
      const keysString = getSearchStr(payload)

      const response = yield call(RequestInterface, {
        url: `${getHost()}/openapi/gs/client/goods/knowledge_classification/knowledge/search?${keysString}`,
        method: 'get',
        cgateToken: cgate_token,
      })
      return response
    },
    // 商品属性
    *ProductAttributes({ payload }, { call, select, put }) {
      const cgateToken = yield select((store) => store.user.cgateToken)
      const shop_id = yield select((store) => store.robot?.robot_shop?.shop_id)
      const cgate_token = cgateToken[shop_id]
      const response = yield call(RequestInterface, {
        url: `${getHost()}/openapi/goods-classification/client/deepingoods/spu?plat_goods_id=${
          payload.plat_goods_id
        }`,
        method: 'get',
        cgateToken: cgate_token,
      })

      return response
    },
    // 商品对比
    *ProductComparison({ payload }, { call, select, put }) {
      const cgateToken = yield select((store) => store.user.cgateToken)
      const cgate_token = cgateToken[payload.shop_id]
      const keysString = getSearchStr(payload)
      const response = yield call(RequestInterface, {
        url: `${getHost()}/openapi/goods-classification/client/deepingoods/comparison_search?${keysString}`,
        method: 'get',
        cgateToken: cgate_token,
      })

      return response
    },
    // 商品知识
    *CommodityKnowledge({ payload }, { call, select, put }) {
      const cgateToken = yield select((store) => store.user.cgateToken)
      const shop_id = yield select((store) => store.robot?.robot_shop?.shop_id)
      const cgate_token = cgateToken[shop_id]
      const keysString = getSearchStr(payload)
      const response = yield call(RequestInterface, {
        url: `${getHost()}/openapi/gs/client/shop/goods/knowledge/search_by_tag?${keysString}`,
        method: 'get',
        cgateToken: cgate_token,
      })

      return response
    },
  },

  reducers: {
    setState: produce((state, action) => ({
      ...state,
      ...action.payload,
    })),
    resetState: produce(() => {
      return { ...lodash.cloneDeep(initialState) }
    }),
  },
  subscriptions: {},
}

export default UserModel
